import { combineReducers } from 'redux';

import {
  SET_CURRENT_SELECTED_VISIT,
  SET_CURRENT_VISITS_DETAILS,
  SET_VISITS_FILTERS,
  SET_VISITS_GRID_SORT_CRITERIA,
  RESET_VISITS_FILTERS,
  SET_VISITS_RECORDS,
  SET_VISITS_LIST_IS_LOADING,
  SET_VISITS_LIST_IS_NOT_LOADING,
} from './actionTypes';

const currentVisitInitialState = {
  agency: '',
  dateReceived: '',
  errors: '',
  node: '',
  partner: '',
  reference: '',
  status: '',
  visitId: '',
};

const currentVisitDetailsInitialState = {
  overview: {},
  aggregatorPayload: [],
  visitPayload: {},
  history: [],
};

const visitsFiltersInitialState = {
  receivedOnStartDate: '',
  receivedOnEndDate: '',
  visitID: '',
  partnerID: 'ALL',
  agencyID: 'ALL',
  status: 'ALL',
  aggregatorID: 'ALL',
  originalReferenceNumber: '',
  pageNumber: 1,
  pageSize: 100,
};

const visitsListInitialState = {
  list: [],
  totalRecords: 0,
  isLoading: false,
};

const visitsGridSortCriteriaInitialState = {
  sortByColumn: 'visitID',
  sortDirection: 'up',
};

const currentSelectedVisitReducer = (
  state = currentVisitInitialState,
  { type = '', visit = { ...currentVisitInitialState } } = {},
) => {
  switch (type) {
    case SET_CURRENT_SELECTED_VISIT:
      return {
        ...state,
        ...visit,
      };

    default:
      return state;
  }
};

const currentVisitGridSortCriteriaReducer = (
  state = visitsGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...visitsGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_VISITS_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const currentVisitsDetailsReducer = (
  state = currentVisitDetailsInitialState,
  { type = '', details = { ...currentVisitDetailsInitialState } } = {},
) => {
  switch (type) {
    case SET_CURRENT_VISITS_DETAILS:
      return {
        ...state,
        ...details,
      };

    default:
      return state;
  }
};

const visitsFiltersReducer = (
  state = visitsFiltersInitialState,
  { type = '', filters = { ...visitsFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_VISITS_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_VISITS_FILTERS:
      return {
        ...state,
        ...visitsFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const visitsListReducer = (state = visitsListInitialState, action = {}) => {
  switch (action.type) {
    case SET_VISITS_RECORDS:
      return {
        ...state,
        ...action.visits,
      };

    case SET_VISITS_LIST_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case SET_VISITS_LIST_IS_NOT_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    default: {
      return state;
    }
  }
};

const visitsReducer = combineReducers({
  currentSelectedVisit: currentSelectedVisitReducer,
  currentVisitsDetails: currentVisitsDetailsReducer,
  visitsFilters: visitsFiltersReducer,
  visitsGridSortCriteria: currentVisitGridSortCriteriaReducer,
  visitsList: visitsListReducer,
});

export { visitsReducer, visitsFiltersInitialState, visitsGridSortCriteriaInitialState };
